/**
 * 環境変数設定
 * Viteの環境変数はVITE_プレフィックスが必要
 */

export interface EnvironmentConfig {
  /** バックエンドAPI のベースURL */
  apiBaseUrl: string
  /** WebSocketサーバーのURL */
  wsUrl: string
  /** 開発環境かどうか */
  isDevelopment: boolean
  /** 本番環境かどうか */
  isProduction: boolean
}

const getEnvironmentConfig = (): EnvironmentConfig => {
  const isDev = import.meta.env.MODE === 'development'
  const isProd = import.meta.env.MODE === 'production'

  // 環境変数から設定を取得、フォールバック値を設定
  const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001'

  const wsUrl = import.meta.env.VITE_WS_URL || 'ws://localhost:3001'

  return {
    apiBaseUrl,
    wsUrl,
    isDevelopment: isDev,
    isProduction: isProd,
  }
}

export const ENV_CONFIG = getEnvironmentConfig()
